import React, { useState, useRef, useEffect, useContext } from "react";
import { useTheme } from "@material-ui/core/styles";

import { useHistory } from "react-router-dom";
import { format } from "date-fns";
// import { SocketContext } from "../../context/Socket/SocketContext";

import usePlaySound from "../../hooks/usePlaySound";

import Popover from "@material-ui/core/Popover";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";
import ChatIcon from "@material-ui/icons/Chat";
import WarningIcon from "@material-ui/icons/Warning";

import TicketListItem from "../TicketListItem";
import useTickets from "../../hooks/useTickets";
import alertSound from "../../assets/sound.mp3";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import Favicon from "react-favicon";
import { getBackendUrl } from "../../config";
import defaultLogoFavicon from "../../assets/favicon.ico";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const useStyles = makeStyles(theme => ({
	tabContainer: {
		overflowY: "auto",
		maxHeight: 350,
		...theme.scrollbarStyles,
	},
	popoverPaper: {
		width: "100%",
		maxWidth: 350,
		marginLeft: theme.spacing(2),
		marginRight: theme.spacing(1),
		[theme.breakpoints.down("sm")]: {
			maxWidth: 270,
		},
	},
	noShadow: {
		boxShadow: "none !important",
	},
}));

const NotificationsPopOver = ({ volume }) => {
	const classes = useStyles();
	const theme = useTheme();

	const history = useHistory();
	// const socketManager = useContext(SocketContext);
	const { user, socket } = useContext(AuthContext);
	const { profile, queues } = user;

	const ticketIdUrl = +history.location.pathname.split("/")[2];
	const ticketIdRef = useRef(ticketIdUrl);
	const anchorEl = useRef();
	const [isOpen, setIsOpen] = useState(false);
	const [notifications, setNotifications] = useState([]);
	const queueIds = queues.map((q) => q.id);
	const { get: getSetting } = useCompanySettings();
    const { setCurrentTicket, setTabOpen } = useContext(TicketsContext);

	const [showTicketWithoutQueue, setShowTicketWithoutQueue] = useState(false);
	const [showNotificationPending, setShowNotificationPending] = useState(false);
	const [showGroupNotification, setShowGroupNotification] = useState(false);

	const [, setDesktopNotifications] = useState([]);

	// Fix 2026-09-21: o alerta de SEFAZ so' disparava a notificacao
	// nativa do navegador (Notification), nunca aparecia no sininho/lista
	// do app - quem nao estivesse olhando a tela na hora exata perdia o
	// aviso ("traz no Google mas nao traz nos botoes de notificacao").
	const [sefazAlerts, setSefazAlerts] = useState([]);

	const { tickets } = useTickets({
		withUnreadMessages: "true"
		// showAll: showTicketWithoutQueue ? "true" : "false"
	});

	const play = usePlaySound(theme.soundTicket || alertSound, volume);
	const soundAlertRef = useRef();
	const playOpenTicketMessage = usePlaySound(theme.soundMessage || alertSound, volume);
	const soundOpenTicketMessageRef = useRef();
	const playAttention = usePlaySound(theme.soundAttention || alertSound, volume);
	const soundAttentionRef = useRef();
	// O backend as vezes emite o evento de mensagem nova mais de uma vez
	// pra uma UNICA mensagem real (ja documentado nesse projeto em outro
	// contexto - multiplas emissoes de socket pro mesmo evento visivel),
	// e o "ticket" anexado pode vir com status diferente entre as
	// emissoes (pending numa, open na outra) - sem isso, os dois sons
	// tocam juntos pra uma so mensagem. Toca no maximo uma vez por id.
	const notifiedMessageIdsRef = useRef(new Set());

	const historyRef = useRef(history);

	useEffect(() => {
		const fetchSettings = async () => {
			try {
				const setting = await getSetting(
					{
						"column": "showNotificationPending"
					}
				);



				if (setting.showNotificationPending === true) {
					setShowNotificationPending(true);
				}

				if (user.allTicket === "enable") {
					setShowTicketWithoutQueue(true);
				}
				if (user.allowGroup === true) {
					setShowGroupNotification(true);
				}
			} catch (err) {
				toastError(err);
			}
		}

		fetchSettings();
	}, [setShowTicketWithoutQueue, setShowNotificationPending]);

	useEffect(() => {
		soundAlertRef.current = play;
		soundOpenTicketMessageRef.current = playOpenTicketMessage;
		soundAttentionRef.current = playAttention;

		if (!("Notification" in window)) {
			console.log("This browser doesn't support notifications");
		} else {
			Notification.requestPermission();
		}
	}, [play]);

	useEffect(() => {
		const processNotifications = () => {
			// if (showTicketWithoutQueue) {
			setNotifications(tickets);
			// } else {
			// 	const newNotifications = tickets.filter(ticket => ticket.status !== "pending");

			// 	setNotifications(newNotifications);
			// }
		}

		processNotifications();
	}, [tickets]);

	useEffect(() => {
		ticketIdRef.current = ticketIdUrl;
	}, [ticketIdUrl]);

	useEffect(() => {
		const companyId = user.companyId;
		// const socket = socketManager.GetSocket();
		// Fix 2026-10-22: socket pode ainda estar null quando user.id ja
		// chegou (useAuth seta o user antes do socket conectar) - gerava
		// "Cannot read properties of null (reading 'on')" e tela branca
		// num F5 onde essa corrida e' perdida com mais frequencia. O
		// efeito ja re-executa quando socket deixa de ser null (esta no
		// dep array).
		if (user.id && socket) {
			const queueIds = queues.map((q) => q.id);

			const onConnectNotificationsPopover = () => {
				socket.emit("joinNotification");
			}

			const onCompanyTicketNotificationsPopover = (data) => {
				if (data.action === "updateUnread" || data.action === "delete") {
					setNotifications(prevState => {
						const ticketIndex = prevState.findIndex(t => t.id === data.ticketId);
						if (ticketIndex !== -1) {
							prevState.splice(ticketIndex, 1);
							return [...prevState];
						}
						return prevState;
					});

					setDesktopNotifications(prevState => {
						const notfiticationIndex = prevState.findIndex(
							n => n.tag === String(data.ticketId)
						);
						if (notfiticationIndex !== -1) {
							prevState[notfiticationIndex].close();
							prevState.splice(notfiticationIndex, 1);
							return [...prevState];
						}
						return prevState;
					});
				}
			};

			const onCompanyAppMessageNotificationsPopover = (data) => {
				// if (
				// 	data.action === "create" && !data.message.fromMe &&
				// 	(
				// 		data.ticket.status !== 'pending' &&
				// 		data.ticket.status !== "lgpd" &&
				// 		data.ticket.status !== "nps"						
				// 	) &&
				// 	(!data.message.read || (data.ticket.status === "pending" && showTicketWithoutQueue && data.ticket.queueId === null) || (data.ticket.status === "pending" && !showTicketWithoutQueue && user?.queues?.some(queue => (queue.id === data.ticket.queueId)))) &&
				// 	(data.ticket.userId === user?.id || !data.ticket.userId)
				// ) {
				// 
				
				if (
					data.action === "create" && !data.message.fromMe &&
					!data.message.read &&
					(data.ticket?.userId === user?.id || !data.ticket?.userId) &&
					(user?.queues?.some(queue => (queue.id === data.ticket.queueId)) ||
						!data.ticket.queueId && showTicketWithoutQueue === true) &&
					(!["pending", "lgpd", "nps", "group"].includes(data.ticket?.status) ||
						(data.ticket?.status === "pending" && showNotificationPending === true) ||
						(data.ticket?.status === "group" && data.ticket?.whatsapp?.groupAsTicket === "enabled" && showGroupNotification === true))
				) {
					setNotifications(prevState => {
						const ticketIndex = prevState.findIndex(t => t.id === data.ticket.id);
						if (ticketIndex !== -1) {
							prevState[ticketIndex] = data.ticket;
							return [...prevState];
						}
						return [data.ticket, ...prevState];
					});

					const shouldNotNotificate =
						(data.message.ticketId === ticketIdRef.current &&
							document.visibilityState === "visible") ||
						(data.ticket.userId && data.ticket.userId !== user?.id) ||
						(data.ticket.isGroup && data.ticket?.whatsapp?.groupAsTicket === "disabled" && showGroupNotification === false);


					if (shouldNotNotificate === true) return;

					handleNotifications(data);
				}
			}

			const onUrgentTicketNotificationsPopover = (data) => {
				if (profile !== "admin") return;
				handleUrgentNotification(data);
			};

			// Fix 2026-09-08: este guard descartava o alerta de SEFAZ pra
			// todo mundo que nao fosse admin. Quem lida com emissao de
			// nota nao necessariamente tem perfil de admin, e foi
			// justamente por isso que o timeout de NFC-e de 08/09/2026
			// 10:17:01 nao chegou a ninguem. O usuario pediu
			// explicitamente pra liberar.
			const onSefazAlertNotificationsPopover = (data) => {
				handleSefazAlert(data);
			};

			socket.on("connect", onConnectNotificationsPopover);
			socket.on(`company-${companyId}-ticket`, onCompanyTicketNotificationsPopover);
			socket.on(`company-${companyId}-appMessage`, onCompanyAppMessageNotificationsPopover);
			socket.on(`company-${companyId}-urgent-ticket`, onUrgentTicketNotificationsPopover);
			socket.on(`company-${companyId}-sefaz-alert`, onSefazAlertNotificationsPopover);

			return () => {
				socket.off("connect", onConnectNotificationsPopover);
				socket.off(`company-${companyId}-ticket`, onCompanyTicketNotificationsPopover);
				socket.off(`company-${companyId}-appMessage`, onCompanyAppMessageNotificationsPopover);
				socket.off(`company-${companyId}-urgent-ticket`, onUrgentTicketNotificationsPopover);
				socket.off(`company-${companyId}-sefaz-alert`, onSefazAlertNotificationsPopover);
			};
		}
	}, [user, profile, queues, showTicketWithoutQueue, socket, showNotificationPending, showGroupNotification]);

	const handleNotifications = data => {
		const { message, contact, ticket } = data;

		if (notifiedMessageIdsRef.current.has(message.id)) return;
		notifiedMessageIdsRef.current.add(message.id);
		if (notifiedMessageIdsRef.current.size > 200) {
			notifiedMessageIdsRef.current = new Set(
				[...notifiedMessageIdsRef.current].slice(-100)
			);
		}

		const options = {
			body: `${message.body} - ${format(new Date(), "HH:mm")}`,
			icon: contact.urlPicture,
			tag: ticket.id,
			renotify: true,
		};
		const notification = new Notification(
			`${i18n.t("tickets.notification.message")} ${contact.name}`,
			options
		);

		notification.onclick = e => {
			e.preventDefault();
			window.focus();
			setTabOpen(ticket.status)
			historyRef.current.push(`/tickets/${ticket.uuid}`);
			// handleChangeTab(null, ticket.isGroup? "group" : "open");
		};

		setDesktopNotifications(prevState => {
			const notfiticationIndex = prevState.findIndex(
				n => n.tag === notification.tag
			);
			if (notfiticationIndex !== -1) {
				prevState[notfiticationIndex] = notification;
				return [...prevState];
			}
			return [notification, ...prevState];
		});
		// Ticket "pending" (ainda nao aceito) = primeira mensagem de um
		// atendimento novo -> som de ticket. Ticket ja "open" (aceito,
		// atribuido) = resposta do cliente num atendimento que ja estava
		// rolando, enquanto voce esta em outra tela -> som separado.
		// eslint-disable-next-line no-console
		console.log("[DIAG-SOM]", { messageId: message.id, ticketId: ticket.id, ticketStatus: ticket.status, ticketUserId: ticket.userId });
		if (ticket.status === "open") {
			soundOpenTicketMessageRef.current();
		} else {
			soundAlertRef.current();
		}
	};

	const handleUrgentNotification = data => {
		const { ticket } = data;
		if (!ticket) return;

		const options = {
			body: `${ticket.contact?.name || "Contato"} - ${ticket.queue?.name || "Sem departamento"}`,
			icon: ticket.contact?.urlPicture,
			tag: `urgent-${ticket.id}`,
			renotify: true,
		};
		const notification = new Notification(
			"⚠ Atendimento marcado como urgente",
			options
		);

		notification.onclick = e => {
			e.preventDefault();
			window.focus();
			setTabOpen(ticket.status)
			historyRef.current.push(`/tickets/${ticket.uuid}`);
		};

		soundAttentionRef.current();
	};

	const handleSefazAlert = data => {
		const { docType, message } = data;
		if (!message) return;

		const options = {
			body: message,
			tag: "sefaz-" + docType,
			renotify: true,
		};
		new Notification("Aviso SEFAZ", options);

		setSefazAlerts(prevState => {
			const alert = {
				id: `${docType}-${Date.now()}`,
				docType,
				message,
				timestamp: new Date(),
			};
			return [alert, ...prevState].slice(0, 10);
		});

		soundAttentionRef.current();
	};

	const handleSefazAlertClick = (alertId) => {
		setSefazAlerts(prevState => prevState.filter(a => a.id !== alertId));
		setIsOpen(false);
		historyRef.current.push("/sefaz-monitor");
	};

	const handleClick = () => {
		setIsOpen(prevState => !prevState);
	};

	const handleClickAway = () => {
		setIsOpen(false);
	};

	const NotificationTicket = ({ children }) => {
		return <div onClick={handleClickAway}>{children}</div>;
	};

	const browserNotification = () => {
		const numbers = "⓿➊➋➌➍➎➏➐➑➒➓⓫⓬⓭⓮⓯⓰⓱⓲⓳⓴";
		if (notifications.length > 0) {
			if (notifications.length < 21) {
				document.title = numbers.substring(notifications.length, notifications.length + 1) + " - " + (theme.appName || "...");
			} else {
				document.title = "(" + notifications.length + ")" + (theme.appName || "...");
			}
		} else {
			document.title = theme.appName || "...";
		}
		return (
			<>
				<Favicon
					animated={true}
					url={(theme?.appLogoFavicon) ? theme.appLogoFavicon : defaultLogoFavicon}
					alertCount={notifications.length}
					iconSize={195}
				/>
			</>
		);
	};

	return (
		<>
			{browserNotification()}

			<IconButton
				onClick={handleClick}
				ref={anchorEl}
				aria-label="Open Notifications"
				color="inherit"
				style={{ color: "inherit" }}
			>
				<Badge overlap="rectangular" badgeContent={notifications.length + sefazAlerts.length} color="secondary">
					<ChatIcon />
				</Badge>
			</IconButton>
			<Popover
				disableScrollLock
				open={isOpen}
				anchorEl={anchorEl.current}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				classes={{ paper: classes.popoverPaper }}
				onClose={handleClickAway}
			>
				<List dense className={classes.tabContainer}>
					{sefazAlerts.map(alert => (
						<ListItem key={alert.id} button onClick={() => handleSefazAlertClick(alert.id)}>
							<WarningIcon fontSize="small" style={{ marginRight: 8, color: "#ed6c02" }} />
							<ListItemText
								primary={alert.message}
								secondary={format(alert.timestamp, "dd/MM HH:mm")}
							/>
						</ListItem>
					))}
					{notifications.length === 0 && sefazAlerts.length === 0 ? (
						<ListItem>
							<ListItemText>{i18n.t("notifications.noTickets")}</ListItemText>
						</ListItem>
					) : (
						notifications.map(ticket => (
							<NotificationTicket key={ticket.id}>
								<TicketListItem ticket={ticket} />
							</NotificationTicket>
						))
					)}
				</List>
			</Popover>
		</>
	);
};

export default NotificationsPopOver;